import * as angular from 'angular';
import * as moment from 'pkp-moment-timezone-all-years';

class RuntimeOverlapValidator implements ng.IDirective {
    public require = 'ngModel';
    public restrict = 'A';
    public scope = false;

    constructor(private moment: moment.MomentStatic) {}

    public link: ng.IDirectiveLinkFn = (
        scope: ng.IScope,
        elem: JQuery,
        attrs: ng.IAttributes,
        ngModelCtrl: ng.INgModelController
    ) => {
        ngModelCtrl.$validators['pkpRuntimeOverlapValidator'] = (
            modelValue: DateInterval
        ): boolean => {
            if (
                !modelValue ||
                !modelValue.start ||
                !modelValue.end ||
                attrs.existingRuntimes == null
            ) {
                return true;
            }

            const index: number = scope.$eval(attrs.pickerIndex);
            const otherRuntimes: DateInterval[] = scope.$eval(
                attrs.existingRuntimes
            );
            const modelStart: moment.Moment = this.moment(modelValue.start);
            const modelEnd: moment.Moment = this.moment(modelValue.end);

            for (let i = 0; i < index; ++i) {
                if (
                    otherRuntimes[i] != null &&
                    otherRuntimes[i] != null &&
                    (modelStart.isBetween(
                        otherRuntimes[i].start,
                        otherRuntimes[i].end,
                        null,
                        '[)'
                    ) ||
                        modelEnd.isBetween(
                            otherRuntimes[i].start,
                            otherRuntimes[i].end,
                            null,
                            '(]'
                        ))
                ) {
                    return false;
                }
            }

            return true;
        };

        scope.$watch(
            () => scope.$eval(attrs.existingRuntimes),
            () => ngModelCtrl.$validate(),
            true
        );
    };
}

RuntimeOverlapValidator.$inject = ['moment'];

angular
    .module('app')
    .directive(
        'pkpRuntimeOverlapValidator',
        (moment) => new RuntimeOverlapValidator(moment)
    );
